import selectAllElements from "../dom/selectAllElements";
import selectSingleElement from "../dom/selectSingleElement";
import { showOrHideElements } from "../dom/showOrHideElements";
import { KNIT_BEANIE_TEXT, MICRO_BEANIE_TEXT } from "./_selectors";

function initialSetup() {
	const oneOfKindInput = selectSingleElement<HTMLInputElement>(
		".pplr-create-a-one-of-a-kind-hat input",
	);
	const bottomLetters = selectSingleElement<HTMLInputElement>(".pplr-bottom-letters input");
	showOrHideElements({
		elements: selectAllElements(KNIT_BEANIE_TEXT),
		show: false,
	});
	showOrHideElements({
		elements: selectAllElements(MICRO_BEANIE_TEXT),
		show: false,
	});
	if (oneOfKindInput) {
		oneOfKindInput.placeholder = "TOP LETTERS";
		// Clear the value if it's just a space (set by Zepto app)
		if (oneOfKindInput.value.trim() === "") {
			oneOfKindInput.value = "";
		}
	}
	if (bottomLetters) {
		bottomLetters.placeholder = "BOTTOM LETTERS";
		// Clear the value if it's just a space (set by Zepto app)
		if (bottomLetters.value.trim() === "") {
			bottomLetters.value = "";
		}
	}
}

export default initialSetup;
